export default __webpack_public_path__ + "static/media/create-additional-product.806b1a40.webp";